module.exports = __webpack_public_path__ + "media/images/ex_pic2-42a7f3cc1eb508f29f69789c279080a0.png";